import React from 'react';

import { useAuth } from '@components/utilComponents/AuthProvider';

import { yandexMetrica, yandexMetricaAuth } from './helpers';
import { useYandexMetricaScript } from './hooks';

export const YandexMetricaManager: React.FC = () => {
  const user = useAuth();
  const metricaId = '21803329';

  const yandexMetricaInstance = React.useMemo(() => {
    return yandexMetrica({ id: metricaId });
  }, [metricaId]);

  const isScriptReady = useYandexMetricaScript(yandexMetricaInstance);

  React.useEffect(() => {
    if (isScriptReady && user) {
      yandexMetricaAuth(metricaId, user);
    }
  }, [isScriptReady, user]);

  return '';
};
